import { useEffect, useRef, useState } from 'react'

interface UseHorizontalNavigationProps {
  activeId?: string | null
}

const SCROLL_OFFSET = 100
const SCROLL_DELAY = 500

export const useHorizontalNavigation = ({
  activeId,
}: UseHorizontalNavigationProps) => {
  const [isVisible, setIsVisible] = useState(false)
  const linkListRef = useRef<HTMLDivElement | null>(null)
  const itemRefs = useRef<Record<string, HTMLElement | null>>({})

  useEffect(() => {
    const linkList = linkListRef.current
    const activeItem = activeId ? itemRefs.current[activeId] : null

    if (!linkList || !activeItem) {
      setIsVisible(true)
      return
    }

    if (linkList.scrollWidth <= linkList.clientWidth) {
      setIsVisible(true)
      return
    }

    linkList.scrollTo({
      left: activeItem.offsetLeft - SCROLL_OFFSET,
      behavior: 'smooth',
    })

    // Wait for scroll to complete, then make visible
    const timeout = setTimeout(() => setIsVisible(true), SCROLL_DELAY)
    return () => clearTimeout(timeout)
  }, [activeId])

  const setItemRef = (el: HTMLElement | null, key: string) => {
    if (el) itemRefs.current[key] = el
  }

  return { linkListRef, isVisible, setItemRef }
}
